import { Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import Joyride, { Step } from "react-joyride";

const TOUR_SEEN_KEY = "tour-team-add";

const step = (title: string, text: string) => (
  <Stack gap={6} ta="right">
    <Title order={5}>{title}</Title>
    <Text size="sm" lh={1.85}>
      {text}
    </Text>
  </Stack>
);

const steps: Step[] = [
  {
    target: "#team-add-steps",
    content: step(
      "سه مرحله برای افزودن",
      "اطلاعات فردی، خدمات و تنظیمات. با زدن روی هر کدام بین مراحل جابه‌جا شو؛ لازم نیست به ترتیب پر کنی.",
    ),
    disableBeacon: true,
    spotlightPadding: 6,
  },
  {
    target: "#team-add-step-services",
    content: step(
      "خدمات، اختیاری است",
      "خدماتی که این فرد انجام می‌دهد را تیک بزن تا موقع ثبت نوبت برایش نمایش داده شوند. اگر هنوز مشخص نیست، رد شو و بعداً از فهرست تیم اضافه کن.",
    ),
    spotlightPadding: 6,
  },
  {
    target: "#team-add-submit",
    content: step(
      "در پایان «افزودن» را بزن",
      "اگر چیزی جا مانده باشد، همان مرحله باز می‌شود. هر وقت خواستی، این تور را از دکمه «راهنما» دوباره ببین.",
    ),
    spotlightPadding: 6,
  },
];

type Props = {
  run: boolean;
  setRun: (run: boolean) => void;
};

/** A three-step tour shown once on the first visit; it can be replayed from the help panel. */
export default function AddMemberTour({ run, setRun }: Props) {
  useEffect(() => {
    try {
      if (!localStorage.getItem(TOUR_SEEN_KEY)) setRun(true);
    } catch {
      /* storage unavailable: skip the automatic tour */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Joyride
      continuous
      run={run}
      steps={steps}
      showSkipButton
      showProgress
      scrollToFirstStep
      disableScrollParentFix
      callback={({ status, action }) => {
        if (status === "finished" || status === "skipped" || action === "close") {
          setRun(false);
          try {
            localStorage.setItem(TOUR_SEEN_KEY, "true");
          } catch {
            /* ignore */
          }
        }
      }}
      locale={{
        back: "قبلی",
        close: "بستن",
        last: "شروع کنم",
        next: "بعدی",
        nextLabelWithProgress: "بعدی ({step} از {steps})",
        skip: "رد کردن",
      }}
      styles={{
        options: { zIndex: 10000, primaryColor: "#5c69ac", width: 340 },
        buttonNext: { background: "var(--mantine-primary-color-filled)", borderRadius: 10, fontFamily: "inherit" },
        buttonBack: { color: "var(--mantine-primary-color-filled)", fontFamily: "inherit" },
        buttonSkip: { fontFamily: "inherit" },
        tooltip: { borderRadius: 16, fontFamily: "inherit" },
        beacon: { display: "none" },
      }}
    />
  );
}
